import React from 'react';
import { TrendingUp, Users, CheckCircle, Lock } from 'lucide-react';
import { colors, spacing, typography } from '../../../../tokens';
import { Card } from '../../../../atoms';
import { formatTokenAmount } from '../utils/formatters';
import type { SwapStatistics } from '../constants';

interface GlobalStatisticsProps {
  statistics: SwapStatistics | undefined;
}

export const GlobalStatistics: React.FC<GlobalStatisticsProps> = ({ statistics }) => {
  if (!statistics) return null;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: spacing.lg,
        marginBottom: spacing.lg,
      }}
    >
      {/* Total Swapped */}
      <Card>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md,
            marginBottom: spacing.sm,
          }}
        >
          <TrendingUp size={24} color={colors.brand.purple.base} />
          <span
            style={{
              fontSize: typography.fontSize.sm,
              color: colors.text.secondary.default,
              fontWeight: typography.fontWeight.medium,
            }}
          >
            Total Swapped
          </span>
        </div>
        <div
          style={{
            fontSize: typography.fontSize['3xl'],
            fontWeight: typography.fontWeight.bold,
            color: colors.text.primary.default,
          }}
        >
          {formatTokenAmount(statistics[0])}
        </div>
        <div
          style={{
            fontSize: typography.fontSize.sm,
            color: colors.text.muted.default,
          }}
        >
          cFAR tokens
        </div>
      </Card>

      {/* Total Users */}
      <Card>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md,
            marginBottom: spacing.sm,
          }}
        >
          <Users size={24} color={colors.brand.cyan.base} />
          <span
            style={{
              fontSize: typography.fontSize.sm,
              color: colors.text.secondary.default,
              fontWeight: typography.fontWeight.medium,
            }}
          >
            Total Users
          </span>
        </div>
        <div
          style={{
            fontSize: typography.fontSize['3xl'],
            fontWeight: typography.fontWeight.bold,
            color: colors.text.primary.default,
          }}
        >
          {statistics[1].toString()}
        </div>
        <div
          style={{
            fontSize: typography.fontSize.sm,
            color: colors.text.muted.default,
          }}
        >
          unique swappers
        </div>
      </Card>

      {/* Available Pool */}
      <Card>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md,
            marginBottom: spacing.sm,
          }}
        >
          <CheckCircle size={24} color={colors.brand.cyan.base} />
          <span
            style={{
              fontSize: typography.fontSize.sm,
              color: colors.text.secondary.default,
              fontWeight: typography.fontWeight.medium,
            }}
          >
            Available Pool
          </span>
        </div>
        <div
          style={{
            fontSize: typography.fontSize['3xl'],
            fontWeight: typography.fontWeight.bold,
            color: colors.text.primary.default,
          }}
        >
          {formatTokenAmount(statistics[2])}
        </div>
        <div
          style={{
            fontSize: typography.fontSize.sm,
            color: colors.text.muted.default,
          }}
        >
          nFAR available
        </div>
      </Card>

      {/* Locked OLD Tokens */}
      <Card>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md,
            marginBottom: spacing.sm,
          }}
        >
          <Lock size={24} color={colors.brand.orange.base} />
          <span
            style={{
              fontSize: typography.fontSize.sm,
              color: colors.text.secondary.default,
              fontWeight: typography.fontWeight.medium,
            }}
          >
            Locked Tokens
          </span>
        </div>
        <div
          style={{
            fontSize: typography.fontSize['3xl'],
            fontWeight: typography.fontWeight.bold,
            color: colors.text.primary.default,
          }}
        >
          {formatTokenAmount(statistics[3])}
        </div>
        <div
          style={{
            fontSize: typography.fontSize.sm,
            color: colors.text.muted.default,
          }}
        >
          cFAR locked
        </div>
      </Card>
    </div>
  );
};
